import React, {useEffect, useState} from "react"
import styled from 'styled-components'
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import { selectOpen, setOpen, setSelectedDashboard, setSelectedDashboardId } from "../ducks/navigationSlice"
import Utils from 'live/lib/utils'

interface DashboardsListProps {
    selectedDashboard: Dashboard
    dashboards: Dashboard[]
    dashboardsType?: string
    fromPage?: boolean
    getHeight: (height: number) => void
}

const DashboardsList: React.FC<DashboardsListProps> = ({ selectedDashboard, dashboardsType, dashboards, fromPage, getHeight}) => {
    const dispatch = useAppDispatch()
    const open = useAppSelector((state) => selectOpen(state))
    const ref = React.useRef(null)

    React.useEffect(() => {
        const onResize = (dom_elem, callback) => {
            const resizeObserver = new ResizeObserver(() => callback() );
            resizeObserver.observe(dom_elem);
        };

        // @ts-ignore
        onResize(ref?.current, function () {
            // @ts-ignore
            getHeight(ref?.current?.clientHeight)
        });
    }, [])

    const handleClickDashboard = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, dashboard: Dashboard) => {
        if ([1,2].includes(e.button) || (e.button == 0 && e.ctrlKey)) {
            const url = window.location.href.replace(/tree_selecteddashboard=\d*/gi, `tree_selecteddashboard=${dashboard.dashboardId}`)
            window.open(url, '_blank', 'noopener,noreferrer');
            return;
        }
        dispatch(setSelectedDashboard(dashboard))
    }

    const handleBack = () => {
        dispatch(setOpen(!Utils.isMobile()))
        dispatch(setSelectedDashboard(undefined))
        dispatch(setSelectedDashboardId(undefined))
    }
    
    return (
        <StyledContainer ref={ref} sidebarOpen={open}>
            {
                fromPage &&
                <div style={{ 
                    height: "33px", 
                    display: "flex", 
                    alignItems: "center", 
                    minWidth: "60px", 
                    justifyContent: "center", 
                    borderBottom: "1px solid var(--gray-300)", 
                    borderRight: "1px solid var(--gray-300)"
                }}>
                    <a
                        onClick={() => handleBack()} 
                    >
                        <i className="fas fa-long-arrow-left" style={{ marginRight: "5px", fontSize: 12, color: "var(--blue-500)" }}></i>
                        Back
                    </a>
                </div>
            }
            <StyledUl isMobile={Utils.isMobile()}>
                {
                    dashboards?.map(dashboard => {
                        return (
                            <li>
                                <a
                                    onMouseUp={(e) => handleClickDashboard(e, dashboard)}
                                    className={ selectedDashboard.dashboardId == dashboard.dashboardId ? "selected" : "" }
                                >
                                    {
                                        dashboard.isFavorite &&
                                        <i
                                            className={`fas fa-star favorite`}
                                        />
                                    }
                                    {dashboard.label}
                                </a>
                            </li>
                        )
                    })
                }
            </StyledUl>
        </StyledContainer>
    )
}

export default DashboardsList

const StyledContainer = styled.div<{ sidebarOpen: boolean }>`
    background: var(--gray-200);
    /* margin-left: ${props => props.sidebarOpen ? 0 : 32}px; */
    border-left: 1px solid var(--gray-400);
    min-height: 33px;
    display: flex;
`

const StyledUl = styled.ul<{ isMobile?: boolean}>`
    padding: 0px;
    margin: 0px;

    height: ${props => props.isMobile ? "33px" : "100%"};
    white-space: ${props => props.isMobile ? "nowrap" : "unset"};
    overflow-x: ${props => props.isMobile ? "auto" : ""};
    overflow-y: ${props => props.isMobile ? "hidden" : ""};

    &::-webkit-scrollbar {
       display: none;
    }

    /* li:first-child {
        margin-left: 1px;
    } */

    /* li:first-child > a {
        color: var(--gray-900);
    } */

    li {
        height: 33px;
        border-bottom: 1px solid var(--gray-300);
        display: inline-block;
        border-radius: 0px;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        border-right: 1px solid var(--gray-300);
        border-image: initial;
        border-top: none;
        background: var(--gray-200);
        border-left: 0px;
        white-space: nowrap;
        font-size: 13px;
        color: var(--blue-500);

        :hover:not(.selected):not(:nth-child(2)) {
            background: var(--gray-100);
        }

        .selected {
            color: var(--gray-900);
            background: var(--gray-300);
        }

        .favorite {
            margin-right: 5px;
            color: var(--yellow-700);
        }

        a {
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            text-decoration: none;
            padding: 6px 14px;
        }
    }
`